import { render, staticRenderFns } from "./InfoListCom.vue?vue&type=template&id=3cf5616c&scoped=true"
import script from "./InfoListCom.vue?vue&type=script&lang=js"
export * from "./InfoListCom.vue?vue&type=script&lang=js"
import style0 from "./InfoListCom.vue?vue&type=style&index=0&id=3cf5616c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf5616c",
  null
  
)

export default component.exports